import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Password } from 'primereact/password';
import { useState } from 'react';

import { useEmployee } from '../../context/employee';

function ChangePassword({ open, employee, onClose }) {
    const { UpdatePassword } = useEmployee();

    const [password, setPassword] = useState('');
    const [updating, setUpdating] = useState(false);

    const onCancel = () => {
        onClose({status: 499, message: ''});
    };

    const buttonDisabled = () => {
        if (!password) {
            return true;
        }

        if (password.length < 8) {
            return true;
        }

        return false;
    };

    const onChange = () => {
        setUpdating(true);
        UpdatePassword({ _id: employee._id, password }, (res) => {
            setUpdating(false);
            onClose(res);
        });
    };

    const FooterContent = (
        <div>
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={onCancel}
                className="p-button-text"
            />
            <Button
                label="Change"
                disabled={buttonDisabled()}
                icon="pi pi-check"
                onClick={onChange}
            />
        </div>
    );

    const passwordFooter = (
        <>
            <Divider />

            <p className="text-red-700">Required - 8 Chars</p>

            <p className="mt-2">Suggestions</p>

            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
            </ul>
        </>
    );

    return (
        <Dialog
            header={`Change Password for ${employee.name}`}
            visible={open}
            onHide={onCancel}
            footer={FooterContent}
            className="w-9"
        >
            <div className="mt-2">
                {updating ? (
                    <div className="card flex flex-wrap gap-3 p-fluid">
                        <div className="flex-auto">
                            <p>Updating password</p>
                        </div>
                    </div>
                ) : (
                    <div className="card flex flex-wrap gap-3 p-fluid">
                        <div className="flex-auto">
                            <label htmlFor="passwordId" className="font-bold block mb-2">
                                Password
                            </label>

                            <Password
                                id="passwordId"
                                minLength={8}
                                toggleMask
                                maxLength={64}
                                footer={passwordFooter}
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    );
}

export default ChangePassword;
